<template>
  <div class="tabs">
    <el-tabs v-model="activeName">
      <el-tab-pane label="系统角色" name="sysRole"></el-tab-pane>
      <el-tab-pane label="项目角色" name="prjRole"></el-tab-pane>
      <el-tab-pane label="文档权限" name="docPerm"> </el-tab-pane>
      <el-tab-pane label="所有项目权限" name="allPrjPerm"> </el-tab-pane>

      <div class="panelInstance">
        <allPrjPerm v-if="activeName === 'allPrjPerm'" />
        <docPerm v-if="activeName === 'docPerm'" />
        <prjRole v-if="activeName === 'prjRole'" />
        <sysRole v-if="activeName === 'sysRole'" />
      </div>
    </el-tabs>
  </div>
</template>
<script>
import allPrjPerm from "./components/allPrjPerm.vue";
import docPerm from "./components/docPerm.vue";
import prjRole from "./components/prjRole.vue";
import sysRole from "./components/sysRole.vue";
export default {
  components: {
    allPrjPerm,
    docPerm,
    prjRole,
    sysRole,
  },
  data: () => {
    return {
      activeName: "sysRole",
    };
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  box-sizing: border-box;
  padding: 10px;
  height: 100%;

  /deep/ .el-tabs {
    display: flex;
    height: 100%;
    flex-flow: column nowrap;

    .el-tabs__header {
      &:hover {
        cursor: pointer !important;
      }
      margin: 0 0 0;
      * {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        color: #999999;
      }
    }
    .el-tabs__item.is-active {
      color: #5584ff !important;
    }
    .el-tabs__active-bar {
      background-color: #5584ff !important;
      height: 1px !important;
    }
    .el-tabs__nav-wrap:after {
      height: 1px;
    }
    .el-tabs__content {
      min-height: 0;
      flex-grow: 1;
      overflow: hidden auto;
    }
  }
  .panelInstance {
    height: 100%;
  }
}
</style>